import { http } from '@/plugins/http';
import { getData } from '@/util/get';

const postLogin = ({code}) => http.post('/auth/login', {code}).then(getData);

const logoutApp = () => http.get('/auth/logout').then(getData);

const loadUserData = () => http.get('/auth/me').then(getData);

export default {
    postLogin,
    logoutApp,
    loadUserData
}



// WEBPACK FOOTER //
// ./src/pages/auth/api/index.js